<template>    
    <section class="hot-prd pt-4 pb-4">        
        <div class="container">
            <div class="group-prd ">
                <div class="row">
                    <div class="blockTitle">				
                        <h2>Sản phẩm nổi bật</h2>
                    </div>
                
                    <div class="tab-content">                    
                        <div class="row">
                            <RwvProductItem
                                v-for="(product, index) of products"
                                :key="index"
                                :currentIndex="index"
                                :product="product"
                            >
                            </RwvProductItem>                             
                        </div>                    
                    </div>
                </div>     
            </div>            
        </div>
    </section>
</template>
<script>
import RwvProductItem from "../ProductItem";
export default {
  name: "RwvHotProduct",
  components: {    
    RwvProductItem
  },
  props: {
    products: Array
  }
};
</script>
